import React from 'react';
import { Switch } from 'antd';
import styled from 'styled-components';
import moment from 'moment';
import { EyeOutlined } from '@ant-design/icons';
import { ButtonWrapper } from 'components';
import { Text } from 'atoms';

export const DATE_FORMAT = 'DD-MM-YYYY';
export const DATE_TIME_FORMAT = 'DD-MM-YY, HH:mm';

export const StatusOptions = [
	{ value: true, label: 'Active' },
	{ value: false, label: 'Inactive' },
];

export const MovementTypeOptions = [
	{ value: 'round_trip', label: 'Round Trip' },
	{ value: 'one_way', label: 'One Way' },
];

const ViewButton = styled(ButtonWrapper)`
	padding: 4px;
	min-width: 32px;
	min-height: 32px;
	display: flex;
	align-items: center;
	justify-content: center;
`;

export const getTableColumns = (navigate, handleStatusToggle) => [
	{
		title: 'Route Name',
		dataIndex: 'route_name',
		key: 'route_name',
		render: (text) => <Text>{text || '-'}</Text>,
	},
	{
		title: 'Project Name',
		dataIndex: 'project_name',
		key: 'project_name',
		render: (text, record) => (
			<Text>
				{text ||
					record?.project?.project_name ||
					record?.project_code ||
					record?.project?.project_code ||
					'-'}
			</Text>
		),
	},
	{
		title: 'Warehouse',
		dataIndex: 'warehouse_name',
		key: 'warehouse',
		render: (text, record) => <Text>{text || record?.warehouse_name || '-'}</Text>,
	},
	{
		title: 'Node Count',
		dataIndex: 'node_count',
		key: 'node_count',
		render: (text, record) => {
			const count = text ?? record?.nodes?.length ?? 0;
			return <Text>{String(count).padStart(2, '0')}</Text>;
		},
	},
	{
		title: 'Movement Type',
		dataIndex: 'movement_type',
		key: 'movement_type',
		render: (text) => <Text style={{ textTransform: 'capitalize' }}>{text || '-'}</Text>,
	},
	{
		title: 'Created at',
		dataIndex: 'created_at',
		key: 'created_at',
		render: (text) => {
			if (!text) return <Text>-</Text>;
			try {
				const time = moment(text);

				if (!time.isValid()) return <Text>-</Text>;

				return (
					<div>
						<Text style={{ whiteSpace: 'pre-line' }}>
							{time.format('DD-MM-YYYY')}
							{'\n'}
							{time.format('hh:mm a')}
						</Text>
					</div>
				);
			} catch (error) {
				return <Text>-</Text>;
			}
		},
	},
	{
		title: 'Created by',
		dataIndex: 'created_by_name',
		key: 'created_by',
		render: (text, record) => <Text>{text || record?.created_by || '-'}</Text>,
	},
	{
		title: 'Status',
		dataIndex: 'is_active',
		key: 'is_active',
		render: (is_active, record) => {
			if (!record) return <Text>-</Text>;
			return (
				<Switch
					checked={is_active === true || is_active === 1}
					checkedChildren="Active"
					unCheckedChildren="Inactive"
					onChange={(checked) => {
						if (handleStatusToggle && record) {
							handleStatusToggle(record, checked);
						}
					}}
				/>
			);
		},
	},
	{
		title: 'View',
		dataIndex: 'id',
		key: 'view',
		render: (id, record) => {
			if (!id || !record) return <Text>-</Text>;
			if (!navigate || typeof navigate !== 'function') return <Text>-</Text>;
			return (
				<ViewButton
					onClick={() =>
						navigate(`/routes/${id}`, { state: { record, openInEditMode: true } })
					}
				>
					<EyeOutlined style={{ fontSize: 18, color: '#1890ff' }} />
				</ViewButton>
			);
		},
	},
];
